import React from 'react'
import {
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  IconButton,
  Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AddIcon from '@mui/icons-material/Add'

import './AccordionCustom.scss'

/**
 * AccordionCustom – Material-UI based replacement mirroring Pepsico-DS Accordion API.
 * NOTE: Existing Pepsico accordion remains untouched; use this component for new work.
 */
function AccordionCustom({
  /* Visual presentation style */
  presentation = 'box-shadow',
  /* Accordion title text */
  accordionTitle = '',
  /* The inner content – use either `content` or children */
  content = null,
  children,
  /* Dark theme flag */
  isDark = false,
  /* Optional separator line */
  separator = false,
  /* Callback when accordion expand/collapse changes */
  onUpdate = () => {},
  /* Callback for add button */
  onClickAdd,
  /* Controlled expand state index – not used in this simple wrapper but kept for API parity */
  selectedItemIndex,
  /* Extra class name */
  className,
  /* Inline style */
  style,
}) {
  const handleChange = (_, expanded) => {
    onUpdate(typeof selectedItemIndex === 'number' ? selectedItemIndex : expanded ? 0 : -1)
  }

  return (
    <div
      data-testid="accordion"
      style={style}
      className={[
        'accordion-wrapper',
        isDark ? 'dark' : 'light',
        separator ? 'separator' : '',
        presentation && `presentation-${presentation}`,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {accordionTitle ? (
        <MuiAccordion
          elevation={presentation === 'box-shadow' ? 1 : 0}
          defaultExpanded={typeof selectedItemIndex === 'number' ? selectedItemIndex === 0 : false}
          square
          onChange={handleChange}
          className="accordion-root"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="accordion-icon" />}
            className="accordion-summary"
          >
            <Typography data-testid="accordion-title" sx={{flexGrow: 1}}>
              {accordionTitle}
            </Typography>

            {onClickAdd && (
              <IconButton size="small" onClick={onClickAdd} edge="end">
                <AddIcon fontSize="small" />
              </IconButton>
            )}
          </AccordionSummary>

          <AccordionDetails className="accordion-details">{content || children}</AccordionDetails>
        </MuiAccordion>
      ) : (
        // No accordionTitle: behave as a simple container
        <div>{content || children}</div>
      )}

      {separator && <Divider />}
    </div>
  )
}

export default AccordionCustom 